import { render, staticRenderFns } from "./NewsFieldInput.vue?vue&type=template&id=0947b024&scoped=true&"
import script from "./NewsFieldInput.vue?vue&type=script&lang=js&"
export * from "./NewsFieldInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0947b024",
  null
  
)

export default component.exports